export type PlatformBannerTone = 'muted' | 'warning' | 'error';

export function getPlatformBannerToneClasses(tone: PlatformBannerTone): string {
  if (tone === 'error') {
    return 'border-red-200 bg-red-50 text-red-900';
  }
  if (tone === 'warning') {
    return 'border-amber-200 bg-amber-50 text-amber-900';
  }
  return 'border-slate-200 bg-slate-50 text-slate-900';
}
